export const USER_KEY = "brrads_user";

export function getStoredUser() {
  const raw = localStorage.getItem(USER_KEY) || "";
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setStoredAuth({ user }) {
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearStoredAuth() {
  localStorage.removeItem("token");
  localStorage.removeItem("brrads_token");
  localStorage.removeItem(USER_KEY);
}

export function readCookie(name) {
  const pairs = String(document.cookie || "").split(";");
  for (const part of pairs) {
    const [k, ...rest] = String(part).trim().split("=");
    if (k === name) return decodeURIComponent(rest.join("="));
  }
  return "";
}
